module.exports = __webpack_public_path__ + "static/media/mark.1bb27b57.svg";